module.exports = "<span ng-class=\"{'mandatory': $ctrl.mandatory}\" ng-transclude=customLabel>{{ $ctrl.labelText }}</span> <span ng-if=$ctrl.hasHelpTextTranslation() class=\"icon-help icon-align-baseline\" tooltip-trigger=\"'outsideClick'\" uib-tooltip-html=$ctrl.help></span> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/label/partial.html
// module id = 548
// module chunks = 0